import Api from 'api'

const config = {
  baseURL: '/api/app/v1',
}
const api = new Api(config)

api.fetchData = ({ ...rest }) => api.get('/countries', { ...rest })

export default api
